import Row from 'Components/Base/Row'
import Template3 from 'Pages/CTLChallenges/Components/Templates/Template3'
import React, { useEffect, useState } from 'react'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import { Paragraph, SectionInfo } from 'types/Challenge'

interface Props {
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function SleepStep2({ step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()
  const [isMobile, setIsMobile] = useState<boolean>()

  useEffect(() => {
    window.scrollTo(0, 0)
    setInfoPage(true)
    setSectionInfo(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      ),
    )
    setStepParagraphs(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      )?.paragraphs,
    )
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })

    if (window.innerWidth < 1200) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [step])

  return (
    <Template3
      imgSrc={sectionInfo?.images.find((image) => image.imageId === 2)?.url ?? ''}
      isMobile={isMobile}
      title={sectionInfo?.titles.find((title) => title.titleId === 1)?.titleText ?? ''}
      textSection={
        <>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 3)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 4)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 5)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 6)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 7)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 8)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 9)?.paragraph ?? ''}
            </p>
          </Row>
        </>
      }
    />
  )
}
